import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { App as AntdApp } from "antd";
import App from "./App";
import { CartProvider } from "./contextApi/CartProvider";
import { HelmetProvider } from "react-helmet-async";

ReactDOM.createRoot(document.getElementById("root")).render(

    <BrowserRouter >
    <AntdApp>
    <CartProvider>
      <HelmetProvider>
      <App />
      </HelmetProvider>
      </CartProvider>
    </AntdApp>
    </BrowserRouter>
  
);
